const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'RFQ',
  description: 'Request For Quote',
  sortOrder: 1,
  name: 'rfq',
  documentKey: 'rfq',
  values: {
    request_for_quote: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'request_for_quote',
      documentKey: 'request_for_quote',
    },
    rfq_remarks_mandate_not_least_trans: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'rfq_remarks_mandate_not_least_trans',
      documentKey: 'rfq_remarks_mandate_not_least_trans',
    },
    rfq_history_log_enable: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'rfq_history_log_enable',
      documentKey: 'rfq_history_log_enable',
    },
  },
};
